export function AdjustableHeight(Splide, Components, options) {
  const track = Components.Elements.track;
  const list = Components.Elements.list;

  const defaults = {
    whileSliding: true,
    speed: '0.4s',
  };

  const custom = options.adjustableHeight || {};
  const settings = {
    whileSliding: custom.whileSliding ?? defaults.whileSliding,
    speed: custom.speed ?? defaults.speed,
  };

  function mount() {
    const events = settings.whileSliding
      ? 'move active resize'
      : 'active resized';

    Splide.on(events, adjustHeight);
  }

  function adjustHeight() {
    const { perPage } = Splide.options;

    if (perPage > 1) {
      track.style.height = '';
      list.style.height = '';
      return;
    }

    const slide = Components.Slides.getAt(Splide.index)?.slide;
    if (!slide) return;

    const slideHeight = slide.offsetHeight;

    const trackStyle = getComputedStyle(track);
    const trackPadding =
      parseInt(trackStyle.paddingTop) + parseInt(trackStyle.paddingBottom);

    const totalHeight = settings.whileSliding
      ? slideHeight + trackPadding
      : slideHeight;

    list.style.alignItems = 'flex-start';

    const element = settings.whileSliding ? track : list;
    element.style.transition = `height ${settings.speed}`;
    element.style.height = `${totalHeight}px`;
  }

  return { mount };
}
